import React from 'react';

// libs
import SanitizedHtml from '../SanitizedHtml';

// types
import PropTypes from 'prop-types';
import Blur from '../../hooks/UseCssBlur';

const CompanySummary = ({
  companyBackground,
  isCompanyApproved,
  isAuthenticated,
}) => {
  const isPreview = window.location.href.indexOf('offer-preview') > -1;

  const showBlur = !isPreview && !isAuthenticated;
  return (
    isCompanyApproved && (
      <div
        className='max-width-div add-margin'
        style={{ padding: '50px 0px 0px 0px' }}
      >
        <div className='black-44'>Company Summary</div>
        <Blur radius={showBlur ? '5px' : '0'} transition='400ms'>
          <div className='highlight w-inline-block'>
            <SanitizedHtml html={companyBackground} />
          </div>
        </Blur>
      </div>
    )
  );
};

CompanySummary.propTypes = {
  companyBackground: PropTypes.string.isRequired,
};

export default CompanySummary;



// WEBPACK FOOTER //
// ./src/components/OfferOverview/CompanySummary.js